<template>
    <main>
        <section class="whiteBox">
            <div class="content">
                <div class="row spaceBetween">
                    <div class="column">
                        <div class="row">
                            <slot name="filter"></slot>
                            <slot name="title"></slot>
                        </div>
                    </div>
                    <div class="column">
                        <div class="row exportParent">
                            <slot name="buttonRight"></slot>
                        </div>
                    </div>
                </div>
                 <hr>
                <table>
                    <slot name="tab"></slot>
                </table>
            </div>
        </section>
    </main>
</template>

<script>
    export default {
        data () {
            return {
                 modalVisibilitiy: false,
            }
        },
        methods: {
            showModal() {
                this.modalVisibilitiy = true;
            },
            closeModal() {
                this.modalVisibilitiy = false;
            },
            exportCSV(arrdata) {
                let csvContent = "data:text/csv;charset=utf-8";
                csvContent += [
                    Object.keys(arrdata[0]).join(";"),
                    ...arrdata.map(item => 
                    Object.values(item).join(";"))
                ].join("\n").replace(/(^\[)|(\]$)/gm, "");
                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "export.csv");
                link.click();
            }
        }
    };
</script>
